var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputerFill = function SvgComputerFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.74 11.24v1.08H9.9v1.08H4.5v-1.08h2.16v-1.08H2.336a.54.54 0 0 1-.536-.544V3.683c0-.3.246-.543.536-.543h9.728a.54.54 0 0 1 .536.543v7.013c0 .3-.246.544-.536.544z"
  })));
};
export default SvgComputerFill;